import { render, staticRenderFns } from "./KatalogBuku.vue?vue&type=template&id=43900435"
import script from "./KatalogBuku.vue?vue&type=script&lang=js"
export * from "./KatalogBuku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports